import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type {
  GTMEventGlycerinButtonClick,
  GTMEventGlycerinDisplayOverlay,
} from '@packages/tracking/src/types/events';

export const useCustomerRatingTracking = () => {
  const dispatchTracking = useTracking();

  // RatingInfo
  const trackRatingInfoDisplayOverlay = (label: string) => {
    dispatchTracking<GTMEventGlycerinDisplayOverlay>({
      event: 'DisplayOverlay',
      DisplayOverlayData: {
        category: 'dv-service-layer-raiting-info',
        label,
      },
    });
  };

  // CustomerRatingsShowAllCallToAction
  const trackShowAllReviewsCallToActionButtonClick = (reviewCount: string) => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        category: 'Alle Bewertungen anzeigen',
        detail: reviewCount,
        label: 'Kundenbewertungen',
      },
    });
  };

  return {
    trackRatingInfoDisplayOverlay,
    trackShowAllReviewsCallToActionButtonClick,
  };
};
